import { Component, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    Confirmation, StripeService, InstituteSearchResult, PriceService, StripeCreateSessionResponse,
    TeamEvent, TicketsService
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController, ViewController } from 'ionic-angular';
import { DisplayMessageComponent } from '../display-message/display-message';
import { TimeService } from '@varsity/services';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the TicketGuardianComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'ticket-guardian',
  templateUrl: 'ticket-guardian.html'
})
export class TicketGuardianComponent extends BaseComponent {
    @ViewChild('tgIframeElement') tgIframeElement;
    @Output() public insuranceSelectionHandler: EventEmitter<any> = new EventEmitter();
    private insuranceInfo: {
        insuranceValues: number[],
        insuranceData: {
            "EventID": number,
            "Description": string,
            "Price": string
        }[]
    } = null;

    private protectionAvailable: boolean = false;
    @Output() protectionAvailableChange = new EventEmitter<boolean>();

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected ticketsService: TicketsService,
        protected stripeService: StripeService,
        protected viewCtrl: ViewController,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "TicketGuardianComponent"
        );
    }

    ngOnInit() {
        super.ngOnInit();

        this.notificationsService.windowMessage$
            .takeUntil(this.componentDestroyed$)
            .subscribe((message) => {
                this.parentReceiveMessage(message);
            });

        this.notificationsService.confirmationChanged$
            .takeUntil(this.componentDestroyed$)
            .subscribe((confirmation) => {
                // update the costs
                this.insuranceInfo = this.getInsuranceDetails(confirmation);
                if (this.insuranceInfo && this.insuranceInfo.insuranceValues.length > 0) {
                    if (!this.protectionAvailable) {
                        this.protectionAvailable = true;
                        this.protectionAvailableChange.emit(true);
                    } else {
                        const contentWindow = (((this.tgIframeElement || {}).nativeElement || {}).contentWindow || (document.getElementById('iframe-id') as any || {}).contentWindow);
                        if (contentWindow) {
                            contentWindow.postMessage({ newcosts: this.insuranceInfo.insuranceValues }, "*");
                        }
                    }
                } else {
                    // no insurance available
                    this.protectionAvailable = false;
                    this.protectionAvailableChange.emit(false);
                }
            });
    }

    sendMessageToTGIframe(confirmation: Confirmation) {
        this.insuranceInfo = this.getInsuranceDetails(confirmation);
        if (this.insuranceInfo) {
            var token = (window as any).__GlobalSettings.TgToken;
            var currencyCode = confirmation.ISOCurrencyCode;
            (this.tgIframeElement.nativeElement.contentWindow || (document.getElementById('iframe-id') as any).contentWindow).postMessage({ costs: this.insuranceInfo.insuranceValues, tgToken: token, currency: currencyCode }, "*");
            // TODO do we need to count them ?
            this.notificationsService.notifyRequestStarted();
        }
    }

    getInsuranceDetails(confirmation: Confirmation): {
        insuranceValues: number[],
        insuranceData: {
            "EventID": number,
            "Description": string,
            "Price": string
        }[]
    } | null {
        const insuranceValues = [];
        const insuranceData = [];

        let ntiTax = 0;
        let donationsTotal = 0;
        const ntiToUse = [];
        const ticketsToUse = [];

        if (!confirmation) {
            return null;
        }

        ntiTax = this.priceService.priceToFloat(confirmation.NTITaxTotal);
        if (confirmation && confirmation.nti) {
            //for (let i = 0; i < confirmation.nti.length; i++) {
            //    let item = confirmation.nti[i];
            //    let itemTax = this.priceService.roundUpAsNumber(this.priceService.priceToFloat(item.AmtPerTicket) * (this.priceService.priceToFloat(item.StateTax) + this.priceService.priceToFloat(item.OutOfStateTax)));
            //    let qty = typeof item.OrderAmtQty === "undefined" ? 0 : item.OrderAmtQty;
            //    let itemQtyTax = this.priceService.priceToFloat(itemTax) * qty;
            //    ntiTax += itemQtyTax;
            //}

            for (let i = 0; i < confirmation.nti.length; i++) {
                let item = confirmation.nti[i];
                if (item.Category.toLowerCase().indexOf("donation") != -1) {
                    if (item.OrderAmtQty > 0 && this.priceService.priceToFloat(item.AmtPerTicket) > 0) {
                        donationsTotal += item.OrderAmtQty * item.AmtPerTicket;
                    }
                }
            }

            for (let i = 0; i < confirmation.nti.length; i++) {
                let item = confirmation.nti[i];
                if (item.Category.toLowerCase().indexOf("donation") == -1) {
                    // this is regular NTI
                    if (!item.ntiTickets && this.priceService.priceToFloat(item.AmtPerTicket) > 0) {
                        ntiToUse.push(item);
                    }
                }
            }
        }

        const totalFees = this.priceService.priceToFloat(confirmation.CCTotal) +
            this.priceService.priceToFloat(confirmation.CCTaxTotal) +
            this.priceService.priceToFloat(confirmation.TaxesTotal) +
            this.priceService.priceToFloat(confirmation.NTICCTotal) +
            this.priceService.priceToFloat(confirmation.NTICCTaxTotal) +
            this.priceService.priceToFloat(ntiTax) +
            this.priceService.priceToFloat((confirmation.perOrderFee || { Amount: "0" }).Amount) +
            this.priceService.priceToFloat((confirmation.perOrderFee || { TaxAmount: "0" }).TaxAmount) +
            this.priceService.priceToFloat(confirmation.FeesTotal);
            
        if (confirmation.tickets) {
            for (let i = 0; i < confirmation.tickets.length; i++) {
                let item = confirmation.tickets[i];
                if (this.priceService.priceToFloat(item.ActualValue) > 0) {
                    ticketsToUse.push(item);
                }
            }
        }

        if (confirmation && confirmation.nti) {
            for (let i = 0; i < confirmation.nti.length; i++) {
                let item = confirmation.nti[i];
                if (item.Category.toLowerCase().indexOf("donation") == -1) {
                    // this is barcoded NTI
                    if (item.ntiTickets && item.ntiTickets.length > 0) {
                        item.ntiTickets.filter(p => this.priceService.priceToFloat(p.ActualValue) > 0).forEach(p => ticketsToUse.push(p));
                    }
                }
            }
        }

        const ntiInsurancePercentage = totalFees / (this.priceService.priceToFloat(confirmation.TransactionTotal) - totalFees - donationsTotal);
        if (ntiToUse && ntiToUse.length > 0) {
            for (let i = 0; i < ntiToUse.length; i++) {
                let ntiItem = ntiToUse[i];
                if (ntiItem.OrderAmtQty > 0) {
                    for (let j = 0; j < ntiItem.OrderAmtQty; j++) {
                        let insuredValue = ntiInsurancePercentage * this.priceService.priceToFloat(ntiItem.AmtPerTicket) + this.priceService.priceToFloat(ntiItem.AmtPerTicket);
                        insuredValue = this.priceService.roundUpAsNumber(insuredValue);
                        insuranceValues.push(insuredValue);
                        insuranceData.push(
                            {
                                "EventID": (ntiItem.EventID > 0) ? ntiItem.EventID : 0,
                                "Description": ntiItem.Description,
                                "Price": insuredValue
                            }
                        )
                    }

                }
            }
        }

        if (ticketsToUse && ticketsToUse.length > 0) {
            for (let i = 0; i < ticketsToUse.length; i++) {
                let ticket = ticketsToUse[i];
                let ticketPrice = this.priceService.priceToFloat(ticket.ActualValue);
                let insuredValue = this.priceService.priceToFloat(ntiInsurancePercentage * this.priceService.roundUpAsNumber(ticketPrice) + this.priceService.roundUpAsNumber(ticketPrice));
                insuredValue = this.priceService.roundUpAsNumber(insuredValue);
                insuranceValues.push(insuredValue);
                insuranceData.push(
                    {
                        "EventID": (ticket.EventID > 0) ? ticket.EventID : 0,
                        "Description": ticket.HomeTeam + " vs " + ticket.Opponent + " on " + ticket.EventDate + " at " + ticket.EventTime + " " + ticket.Level + ":" + ticket.Section + ":" + ticket.Row + ":" + ticket.Seat,
                        "Price": insuredValue
                    }
                )
            }
        }

        return { insuranceValues, insuranceData };
    }

    parentReceiveMessage(event): void {
        this.notificationsService.confirmationChanged$
            .take(1)
            .subscribe((value) => {
                if (event && event.data && event.data.info && value) {
                    switch (event.data.info) {
                        case "iframe-loaded":
                            {
                                this.notificationsService.notifyRequestCompleted();
                                if (value.InsuranceMessage && value.InsuranceMessage.length > 0) {
                                    this.showNotification(value.InsuranceMessage, undefined, undefined, "notification");
                                }
                                break;
                            }
                        case "iframe-optInCb":
                            {
                                let insuranceTotals = this.priceService.priceToFloat(event.data.totalCosts);
                                let tgQuoteToken = event.data.quoteToken;
                                this.insuranceSelectionHandler.emit({
                                    selected: true,
                                    token: tgQuoteToken,
                                    total: insuranceTotals,
                                    data: this.insuranceInfo
                                });
                                //$scope.totalAmount = utilsModel.round(($scope.totalAmountDue() + $scope.ntiTotal() + parseFloat($scope.insuranceTotals)), 2);
                                //this.showNotification("You have agreed to protect your purchase", undefined, undefined, "success");

                                super.showPopover(DisplayMessageComponent, {
                                    icon: "card",
                                    header: "Protecting purchase",
                                    content: ["You have agreed to protect your purchase. This will be processed in a different transaction"],
                                    buttons: [{ tag: 'ok', text: 'Ok' }],
                                    footer: null
                                }, 'display-message', (data) => {

                                });
                                break;
                            }
                        case "iframe-updatedCb":
                            {
                                this.notificationsService.notifyRequestCompleted();
                                let insuranceTotals = this.priceService.priceToFloat(event.data.totalCosts);
                                let tgQuoteToken = event.data.quoteToken;
                                this.insuranceSelectionHandler.emit({
                                    selected: undefined,
                                    token: tgQuoteToken,
                                    total: insuranceTotals,
                                    data: this.insuranceInfo
                                });
                                break;
                            }
                        case "iframe-optOutCb":
                            {
                                this.insuranceSelectionHandler.emit({
                                    selected: false,
                                    token: "",
                                    total: 0
                                });
                                this.showNotification("You have declined to protect your purchase", undefined, undefined, "warning");
                                break;
                            }
                        case "page-rendered":
                            {
                                this.sendMessageToTGIframe(value);
                                break;
                            }
                        case "iframe-height":
                            {
                                var iframeWrapperHeight;
                                if (event.data.iframeHeight) {
                                    iframeWrapperHeight = event.data.iframeHeight + 25 + "px";
                                    this.tgIframeElement.nativeElement.style.height = iframeWrapperHeight;
                                }
                                break;
                            }
                        case "iframe-onErrorCb": {
                            this.notificationsService.notifyRequestCompleted();
                            break;
                        }
                    }
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/components/ticket-guardian/ticket-guardian.ts